import api from "../utils/http-common";
var REQUEST_EMAIL_URL = "/api/v1/user/send-email-confirmation";
export function requestEmail(loginId) {
    return api.post(REQUEST_EMAIL_URL, { loginId: loginId });
}
